export default "__VITE_ASSET__59c51ce0__"